export type FilterOptionValue = string | number;

export type FilterChip = {
  key: string;
  label: string;
  show: boolean;
  clear: () => void;
};

export type FilterSelectOption = {
  value: FilterOptionValue;
  label: string;
  disabled?: boolean;
};

export type FilterBarItem = {
  /** Имя слота с самим фильтром. */
  key: string;
  /** Выбрано значение: скрытый фильтр считается на кнопке «Ещё». */
  active?: boolean;
};

/**
 * Сколько фильтров остаётся в ряду: скрываются с конца списка, поэтому важный ставь первым.
 * Если скрыт хотя бы один, в ряду нужно место и под кнопку «Ещё».
 */
export const countVisibleFilters = (
  widths: readonly number[],
  available: number,
  more: number,
  gap: number,
): number => {
  const fullWidth = (count: number): number => widths.slice(0, count).reduce((sum, width) => sum + width + gap, 0);

  if (fullWidth(widths.length) - gap <= available) return widths.length;

  let count = widths.length - 1;
  while (count > 0 && fullWidth(count) + more > available) count -= 1;

  return count;
};
